import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { UploadOutlined } from "@ant-design/icons-vue";
import { FileService } from "@/api/services/FileService";
import { message } from "ant-design-vue";
import { UploadRequestOption } from "ant-design-vue/lib/vc-upload/interface";


export default /*@__PURE__*/_defineComponent({
  __name: 'FileUpload',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const handleRequest = async (option: UploadRequestOption) => {
  const res = await FileService.Upload({ file: option.file as Blob });
  if (res.code === 0) {
    message.success("上传成功");
    emit("update:modelValue", res.data);
  } else {
    message.error(res.msg);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!

  return (_openBlock(), _createBlock(_component_a_upload, {
    customRequest: handleRequest,
    "show-upload-list": false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_button, null, {
        default: _withCtx(() => [
          _createVNode(_unref(UploadOutlined)),
          _cache[0] || (_cache[0] = _createTextVNode(" 上传文件 "))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})